import { createMapColorThemeContext } from "@app/shared/map-appearance/MapColorThemeContext";
import {
  COMPETITIVE_INSIGHTS_COLOR_SLOT_DEFINITIONS,
  COMPETITIVE_INSIGHTS_DEFAULT_COLOR_THEME,
  COMPETITIVE_INSIGHTS_PRESET_THEMES,
} from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsColorThemeConstants";

const CompetitiveInsightsColorTheme = createMapColorThemeContext({
  defaultTheme: COMPETITIVE_INSIGHTS_DEFAULT_COLOR_THEME,
  localStorageKeySuffix: "competitive-insights-color-theme",
  presetThemes: COMPETITIVE_INSIGHTS_PRESET_THEMES,
  slotDefinitions: COMPETITIVE_INSIGHTS_COLOR_SLOT_DEFINITIONS,
});

export { CompetitiveInsightsColorTheme };